// yard/YardCanvas.jsx - Main 3D Canvas wrapper with performance settings
import React, { Suspense, useMemo } from 'react';
import { Canvas } from '@react-three/fiber';
import YardScene from './YardScene';

// Simple loading fallback
const LoadingFallback = () => (
  <mesh>
    <boxGeometry args={[1, 1, 1]} />
    <meshBasicMaterial color="#666" wireframe />
  </mesh>
);

const YardCanvas = ({ deals, darkMode, onDogSelect }) => {
  // Auto-zoom camera based on number of dogs
  const cameraZ = useMemo(() => {
    const count = deals?.length || 0;
    if (count > 75) return 55;
    if (count > 25) return 45;
    return 35;
  }, [deals?.length]);

  return (
    <div style={{
      width: '100%',
      height: '100%',
      position: 'relative',
      background: darkMode
        ? 'linear-gradient(180deg, #0a0f1a 0%, #1a2744 50%, #2d4a3e 100%)'
        : 'linear-gradient(180deg, #87ceeb 0%, #98d8c8 50%, #90EE90 100%)'
    }}>
      <Canvas
        shadows
        dpr={[1, 1.5]}
        camera={{ position: [0, 25, cameraZ], fov: 50, near: 0.1, far: 500 }}
        gl={{
          antialias: true,
          alpha: true,
          powerPreference: 'default'
        }}
        onCreated={({ gl }) => {
          gl.setClearColor(darkMode ? '#0a0f1a' : '#87ceeb', 1);
        }}
      >
        <Suspense fallback={<LoadingFallback />}>
          <YardScene deals={deals} darkMode={darkMode} onDogSelect={onDogSelect} />
        </Suspense>
      </Canvas>
    </div>
  );
};

export default YardCanvas;
